'use client';

import React from 'react';
import Box from '../../../atoms/Box/Box';
import Dropdown from '../../../atoms/Dropdown/Dropdown';

interface LanguageSelectorProps {
  theme?: 'light' | 'dark';
  selectedLanguage: string;
  onLanguageSelect: (locale: string) => void;
  inSlider?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  theme = 'dark',
  selectedLanguage,
  onLanguageSelect,
  inSlider = false,
}) => {
  // Language options with grouping by region
  const languageOptions = [
    {
      groupLabel: 'North America',
      data: [
        { value: 'en-us', label: 'United States - English' },
        { value: 'en-ca', label: 'Canada - English' },
        { value: 'fr-ca', label: 'Canada - Français' },
      ],
    },
    {
      groupLabel: 'Europe',
      data: [
        { value: 'de-de', label: 'Deutschland - Deutsch' },
        { value: 'de-ch', label: 'Schweiz - Deutsch' },
        { value: 'fr-ch', label: 'Suisse - Français' },
        { value: 'nl-nl', label: 'Nederland - Nederlands' },
        { value: 'nb-no', label: 'Norge - Norsk' },
      ],
    },
    {
      groupLabel: 'Middle East',
      data: [
        { value: 'en-sa', label: 'KSA - English' },
        { value: 'ar-sa', label: 'المملكة العربية السعودية - العربية' },
        { value: 'en-ae', label: 'UAE - English' },
        { value: 'ar-ae', label: 'الإمارات العربية المتحدة - العربية' },
      ],
    },
  ];

  return (
    <Box>
      <Dropdown
        theme={theme}
        variant="list"
        size="medium"
        name="language-selector"
        label="Language"
        options={languageOptions}
        selectedOption={selectedLanguage}
        placeholder="Select Language"
        handleSelect={onLanguageSelect}
        gaComponent="sidebar-language-selector"
        logEvents={false}
        inSlider={inSlider}
      />
    </Box>
  );
};

LanguageSelector.displayName = 'LanguageSelector';

export default LanguageSelector;
